import _object_spread from "@swc/helpers/src/_object_spread.mjs";
export var EnvironmentFromFile;
(function(EnvironmentFromFile) {
    EnvironmentFromFile["Fred"] = "FRED";
    EnvironmentFromFile["IDontWantThisCar"] = "I_DONT_WANT_THIS_CAR";
})(EnvironmentFromFile || (EnvironmentFromFile = {}));
export var Env = _object_spread({}, EnvironmentFromFile);
